// PII detection and redaction types

export interface PIIItem {
  type: PIIType
  original: string
  redacted: string
  confidence: number
  context: string
}

export type PIIType =
  | 'name' | 'email' | 'phone' | 'ssn' | 'address'
  | 'date_of_birth' | 'bank_account' | 'credit_card'
  | 'passport' | 'medical_record' | 'ip_address'
  | 'national_id' | 'company_contact' | 'other'

export interface PIIDetectionResult {
  pii_found: PIIItem[]
  total_found: number
  has_critical: boolean
  redacted_text: string
}

export interface PIIDecision {
  decision: 'redact' | 'keep'
  item: PIIItem
}

export const PII_TYPE_LABELS: Record<PIIType, string> = {
  name: 'Personal Name',
  email: 'Email Address',
  phone: 'Phone Number',
  ssn: 'Social Security / National ID',
  address: 'Physical Address',
  date_of_birth: 'Date of Birth',
  bank_account: 'Bank Account',
  credit_card: 'Credit Card',
  passport: 'Passport / License',
  medical_record: 'Medical Record',
  ip_address: 'IP Address',
  national_id: 'National ID',
  company_contact: 'Company Contact',
  other: 'Other PII',
}

export const PII_RISK_LEVEL: Record<PIIType, 'critical' | 'high' | 'medium'> = {
  ssn: 'critical',
  credit_card: 'critical',
  bank_account: 'critical',
  passport: 'critical',
  medical_record: 'critical',
  national_id: 'high',
  name: 'high',
  email: 'high',
  phone: 'medium',
  address: 'high',
  date_of_birth: 'high',
  ip_address: 'medium',
  company_contact: 'medium',
  other: 'medium',
}
